import React from 'react';
import { SearchInput } from '../../../Controls/Input/SearchInput';
import { useFilterField } from '../../hooks/useFilterField';
import { useFilterBarContext } from '../../state/FilterBarContext';
import type { TextSearchFilterConfig } from '../../types';

export interface TextSearchFilterControlProps {
  name: string;
  placeholder?: string;
}

export const TextSearchFilterControl: React.FC<TextSearchFilterControlProps> = ({ name, placeholder: placeholderOverride }) => {
  const { value, setValue, config } = useFilterField(name);
  const { size } = useFilterBarContext();

  if (!config || config.type !== 'TEXT_SEARCH') {
    return null;
  }

  const ts = config as TextSearchFilterConfig;

  return (
    <SearchInput
      {...ts.controlProps}
      value={(value as string) ?? ''}
      onChange={(v) => setValue(v)}
      debounceTime={ts.debounceMs ?? ts.controlProps?.debounceTime}
      size={ts.size ?? size}
      placeholder={placeholderOverride ?? ts.placeholder ?? 'Search'}
      // Per-field clear via antd's native X, gated on `clearable`.
      allowClear={ts.clearable !== false}
    />
  );
};
